import { Components } from '@mui/material/styles';

const getMuiBreadcrumbs = (): Components['MuiBreadcrumbs'] => ({
  styleOverrides: {
    root: {
      backgroundColor: 'transparent',
      padding: '4px 0',
      minHeight: '34px',
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'nowrap',
      whiteSpace: 'nowrap',
      fontSize: '13px',
      '& .MuiBreadcrumbs-ol': {
        display: 'flex',
        flexWrap: 'nowrap',
        whiteSpace: 'nowrap',
        alignItems: 'center',
      },
      '& .MuiBreadcrumbs-li': {
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'nowrap',
        whiteSpace: 'nowrap',
      },
      '& .MuiBreadcrumbs-separator': {
        color: '#1A1A1A',
        margin: '0 4px',
        flexShrink: 0,
        whiteSpace: 'nowrap',
        '& svg': {
          fontSize: '13px',
        },
      },
      '& .MuiButton-root': {
        display: 'block',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        minHeight: '24px',
        padding: '0 2px',
        maxWidth: 150,
        minWidth: 0,
        backgroundColor: 'transparent',
        fontSize: '12px',
        lineHeight: '18px',
        flexShrink: 1,
        '&:hover, &:focus, &:active': {
          backgroundColor: 'transparent !important',
          boxShadow: 'none !important',
          textDecoration: 'underline',
        },
        '& div': {
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        },
      },
      // Typography styles for the last breadcrumb item
      '& .MuiTypography-root': {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '12px',
        lineHeight: '18px',
        padding: '0 4px',
        direction: 'ltr',
        fontWeight: 'bold',
        minWidth: 0,
        flexShrink: 0,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        '& span': {
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          display: 'inline-flex',
          alignItems: 'center',
          gap: '4px',
          minWidth: 0,
        },
      },
    },
    li: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'start',
      flexShrink: 0,
      whiteSpace: 'nowrap',
      flexWrap: 'nowrap',
      backgroundColor: 'transparent',
      '& p': {
        '& span': {
          display: 'block',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          maxWidth: '14rem',
        },
        '& div': {
          display: 'flex',
          '& span': {
            display: 'block',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            maxWidth: '14rem',
          },
        },
      },
    },
  },
});

export default getMuiBreadcrumbs;
